import firebase from 'firebase/app'

let firebaseConfig = process.env.REACT_APP_FIREBASE_CREDENTIAL
firebaseConfig = atob(firebaseConfig)
firebaseConfig = JSON.parse(firebaseConfig)

export const fb = firebase.initializeApp(firebaseConfig)
